import { Component, effect, Input } from '@angular/core';
import { Attachment } from '@modules/search/interfaces/interface';
import { SearchService } from '@modules/search/services/search.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TooltipModule } from 'primeng/tooltip';
import { LoggerService } from '../../../../../../services/logger.service';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { ProjectService } from '@core/services/project/project.service';
import { AuthService } from '@core/services/auth/auth.service';

@Component({
  selector: 'app-attachment-view',
  standalone: true,
  imports: [MenuModule, ButtonModule, TooltipModule, SvgIconComponent],
  templateUrl: './attachment-view.component.html',
  styleUrl: './attachment-view.component.scss',
})
export class AttachmentViewComponent {
  @Input() attachments: Attachment[] | null = null;

  isDownloading: boolean = false;
  winNum: number = 1;
  showAllAttachments: boolean = false;
  isHovered: boolean = false;

  attachmentOptions: any[] = [
    {
      icon: 'open_in_new',
      title: 'Open Document',
      func: (attachment: Attachment, $event: Event) =>
        this.openPreview(attachment),
    },
  ];

  constructor(
    private _search: SearchService,
    private _messageService: MessageService,
    private _logger: LoggerService,
    private _project: ProjectService,
    private _auth: AuthService
  ) {
    effect(() => {
      this._project.currentProject();
      if (this._project.currentProject().isAllowDownload === true) {
        this.attachmentOptions[1] = {
          icon: 'download',
          title: 'Download',
          func: (attacment: Attachment, $event: Event) =>
            this.downloadAttachment(attacment, $event),
        };
      }
    });
  }

  openPreview(attachment: Attachment) {
    localStorage.setItem('filePreviewData', JSON.stringify(attachment));
    let win = 'preview' + this.winNum;
    this.winNum++;
    window.open(
      '/preview',
      win,
      'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1000,height=800'
    );
  }

  getFile(extension: string) {
    const base64String = this._search.iconFile[extension]
      ? this._search.iconFile[extension]
      : this._search.iconFile[''];
    return 'data:image/png;base64,' + base64String;
  }

  downloadAttachment(attachment: Attachment, event: any) {
    if (this.isDownloading) return;
    let filePath = attachment.filePath;
    if (
      this._auth.appConfig().downloadPathAddCheck &&
      this._auth.appConfig().downloadPathAddCheck[
        this._project.currentProject().name
      ]
    ) {
      let checkValue =
        this._auth.appConfig().downloadPathAddCheck[
          this._project.currentProject().name
        ];
      if (!filePath.startsWith(checkValue)) {
        filePath = checkValue + `/` + filePath;
      }
    }

    let param = {
      filePath: filePath,
    };
    this._search.downloadDocFile(param).subscribe({
      next: (response) => {
        let blob = new Blob([response], { type: 'application/octet-stream' });
        let url = window.URL.createObjectURL(blob);
        let a: any = document.createElement('a');
        a.href = url;
        a.download = attachment.filePath.split('/').pop();
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this._messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'File downloaded successfully',
          key: 'tr',
        });
      },
      error: (error) => {
        let errorMessage = '';
        if (
          error.error instanceof Blob &&
          error.error.type === 'application/json'
        ) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errObj = JSON.parse(reader.result as string);
              errorMessage = errObj.message || '';
            } catch (e) {
              errorMessage = 'Unknown error';
            }
            this._logger.error('Download error:', errorMessage);
            this._messageService.add({
              severity: 'warn',
              summary: error.statusText || 'Something went wrong',
              detail: errorMessage || 'Error while downloading file',
              key: 'tr',
            });
          };
          reader.readAsText(error.error);
        } else {
          errorMessage = error.message || 'Unknown error';
          this._logger.error('Download error:', errorMessage);
          this._messageService.add({
            severity: 'warn',
            summary: error.statusText || 'Something went wrong',
            detail: errorMessage || 'Error while downloading file',
            key: 'tr',
          });
        }
      },
    });
  }
}
